// utils/fontSizesByLang.js
export const fontSizesByLang = {
  es: {
    tittlefont: { base:'250%', md: '220%', lg: '75px'},
    textfont: { base: '15px', md: '15px', lg: '18px' },
    textimage: { base:'15px', md: '12px', lg: '15px'}

  },
  en: {
    tittlefont: { base:'250%', md: '250%', lg: '80px' },
    textfont: { base:'15px', md: '10px', lg: '18px'},
    textimage: { base:'15px', md: '12px', lg: '15px'}
  },

};
